import { FC } from 'react'

import { v4 as uuidV4 } from 'uuid'

import { ListPager } from '@style-port/roov-ui-components-react'
import { Icon } from 'src/components/atoms'

type Props = {
  totalPage: number
  currentPage: number
  select: (pageNumber: number) => void
  className?: string
}

export const Pagination: FC<Props> = ({ totalPage, currentPage, select, className }) => {
  return (
    <div className={className}>
      <ul className="tw-centering">
        <li className="tw-mr-s-1">
          <button
            type="button"
            onClick={() => currentPage !== 1 && select(currentPage - 1)}
            className={currentPage === 1 ? 'tw-cursor-default' : 'tw-cursor-pointer'}
          >
            <Icon
              path="chevron-left/soft/line"
              size="--r2"
              className={
                currentPage === 1
                  ? 'tw-text-standardText-disable'
                  : 'tw-text-standardText-secondary'
              }
            />
          </button>
        </li>
        {Array.from({ length: totalPage }).map((_, index) => (
          <ListPager
            as="li"
            key={uuidV4()}
            isSelected={index + 1 === currentPage}
            onClick={() => select(index + 1)}
          >
            {index + 1}
          </ListPager>
        ))}
        <li className="tw-ml-s-1">
          <button
            type="button"
            onClick={() => currentPage !== totalPage && select(currentPage + 1)}
            className={currentPage === totalPage ? 'tw-cursor-default' : 'tw-cursor-pointer'}
          >
            <Icon
              path="chevron-right/soft/line"
              size="--r2"
              className={
                currentPage === totalPage
                  ? 'tw-text-standardText-disable'
                  : 'tw-text-standardText-secondary'
              }
            />
          </button>
        </li>
      </ul>
    </div>
  )
}
